import { useMemo } from "react";
import { useDonate } from "./DonateModal";
import { SkyLayer } from "./Skyline";

const Stars = () => {
  const stars = useMemo(
    () =>
      Array.from({ length: 90 }, () => {
        const big = Math.random() < 0.15;
        return {
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 60}%`,
          opacity: +(Math.random() * 0.6 + 0.2).toFixed(2),
          ...(big ? { width: 3, height: 3 } : {}),
        };
      }),
    []
  );
  return (
    <div className="stars" aria-hidden="true">
      {stars.map((s, i) => <i key={i} style={s} />)}
    </div>
  );
};

export const Hero = () => {
  const openDonate = useDonate();
  return (
  <section className="hero" id="home" data-testid="hero-section">
    <Stars />
    <div className="glow" aria-hidden="true" />
    <SkyLayer kind="far" speed="0.12" />
    <SkyLayer kind="mid" speed="0.28" />
    <SkyLayer kind="near" speed="0.5" />
    <div className="wrap hero-in">
      <img className="hero-logo" src="/assets/logo-dark.jpg" alt="Davis Infinite Care Corporation logo" data-testid="hero-logo" />
      <h1 data-testid="hero-title">Empowering youth. Strengthening families. Inspiring communities.</h1>
      <p>We help people across South Florida find and connect with the support they need, so no one has to face life's challenges alone.</p>
      <div className="ctas">
        <a className="btn btn-gold" href="#services" data-testid="hero-find-support-button">Find support</a>
        <button type="button" className="btn btn-ghost" onClick={openDonate} data-testid="hero-donate-button">Make a donation</button>
      </div>
    </div>
    <a className="scroll-cue" href="#about" aria-label="Scroll to About Us" data-testid="hero-scroll-cue">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 9l6 6 6-6" /></svg>
    </a>
  </section>
  );
};
